export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_24-0b18041d319b43d2f2d858607da66e8c.jpg";